import { render, staticRenderFns } from "./ed-homework-student-section-item.vue?vue&type=template&id=4c65b432&scoped=true&"
import script from "./ed-homework-student-section-item.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-student-section-item.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-student-section-item.scss?vue&type=style&index=0&id=4c65b432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c65b432",
  null
  
)

export default component.exports